import isDowngrading from "../utils/isDowngrading";
import isUpgrading from "../utils/isUpgrading";
import { UrlProvider } from "../../../../../../api/UrlProvider";
import showPaymentBarDowngradeToFreeModal from "../utils/showPaymentBarDowngradeToFreeModal";
import React from "react";
import hasSubscription from "../utils/hasSubscription";
import getIsFree from "../utils/getIsFree";
import hasSupportedPaymentMethod from "../utils/hasSupportedPaymentMethod";
import { compose } from "redux";
import withTranslations from "../../../../../../hocs/withTranslations";
import { withRouter } from "react-router";
import { resolveInvoiceFormDataForPayment } from "../../../../../../lib/payment/resolveInvoiceFormDataForPayment";

const PaymentButton = ({
  selectedPlan,
  onPaymentButtonClick,
  userData,
  setShowModal,
  selectedPaymentMethod,
  paymentFormLoading,
  translate,
  paymentDetails,
  history,
  locale,
  currentCurrencyOfferByPeriod,
  className = "button py-4.5 px-11 ml-auto shrink-0 z-10",
  onClick,
  invoiceFromRef,
  showInvoiceForm,
  onValidationFailure
}) => {
  const isFree = getIsFree({ currentCurrencyOfferByPeriod });

  const handlePayClick = async () => {
    const invoiceFormData = await resolveInvoiceFormDataForPayment({
      showInvoiceForm,
      invoiceFormRef: invoiceFromRef
    });

    if (invoiceFormData === false) {
      onValidationFailure?.();
      return;
    }

    if (!userData) {
      onPaymentButtonClick({ invoiceFormData });
    } else {
      setShowModal(true);
    }

    onClick?.();
  };

  return currentCurrencyOfferByPeriod && !isFree ? (
    hasSupportedPaymentMethod ? (
      <button
        className={className}
        type={"button"}
        disabled={userData && (!selectedPaymentMethod || paymentFormLoading)}
        onClick={handlePayClick}
      >
        {!userData
          ? translate("Log in to proceed to payment")
          : isDowngrading({
              userCurrentPlan: userData?.current_plan,
              selectedPlan
            })
          ? translate("plans_payment-bar_downgrading")
          : isUpgrading({
              userCurrentPlan: userData?.current_plan,
              selectedPlan
            })
          ? translate("plans_payment-bar_upgrading")
          : translate("plans_payment-bar_go-to_payment")}
      </button>
    ) : null
  ) : userData ? (
    isDowngrading({
      userCurrentPlan: userData?.current_plan,
      selectedPlan
    }) ? (
      hasSubscription ? (
        <button
          className={className}
          type={"button"}
          onClick={() => {
            history.push(
              UrlProvider.getUrl("fe.settingsPageCategory", {
                locale,
                settingsCategory: "payments"
              })
            );

            onClick?.();
          }}
        >
          {translate("plans_payment-bar_cancel-subscription")}
        </button>
      ) : (
        <button
          className={className}
          type={"button"}
          onClick={() => {
            showPaymentBarDowngradeToFreeModal({
              translate,
              userData,
              paymentDetails,
              selectedPlan
            });

            onClick?.();
          }}
        >
          {translate("plans_payment-bar_cancel-no-subscription")}
        </button>
      )
    ) : null
  ) : (
    <button
      className={className}
      type={"button"}
      onClick={() => {
        history.push(UrlProvider.getUrl("fe.register", { locale }));

        onClick?.();
      }}
    >
      {translate("plans_payment-bar_use-for-free")}
    </button>
  );
};

export default compose(withTranslations, withRouter)(PaymentButton);
